import { DividerLine } from "components/icons/DividerLine";
import { SelectedFloatingControl } from "components/SelectedFloatingControl/SelectedFloatingControl";
import React, { useMemo } from "react";
import { CompanyGroup } from "types/Models/groups";
import { Table } from "react-table-8.10.7";
import { Button } from "components/DesignSystem/Button/Button";
import { Cross } from "components/icons/Cross";
import { OpsBulkAction } from "./OpsBulkAction";

type TableSelectionControlsProps = {
  table: Table<CompanyGroup>;
  resetSelection: () => void;
};

export const ServiceTeamBulkActions = ({
  table,
  resetSelection,
}: TableSelectionControlsProps) => {
  const selectedRows = table.getState().rowSelection;

  const allSelectedRows: string[] = useMemo(
    () =>
      Object.entries(selectedRows)
        .filter(([key, value]) => value)
        .map(([key]) => key),
    [selectedRows]
  );

  return (
    <SelectedFloatingControl>
      {allSelectedRows.length > 0 && (
        <>
          <span className="t-whitespace-nowrap t-text-subtext t-text-text-60">
            {allSelectedRows.length} selected
          </span>
          <span className="t-text-neutral-10 t-h-full">
            <DividerLine />
          </span>
          <OpsBulkAction
            selectedRows={allSelectedRows}
            resetSelection={resetSelection}
          />
          <Button
            customType="ghost_icon"
            size="xsmall"
            onClick={resetSelection}
          >
            <Cross />
          </Button>
        </>
      )}
    </SelectedFloatingControl>
  );
};
